import {
  useSbsCellState,
  type SbsCellStateMap,
} from "@platform/mpx-quotes-grid";
import { useEffect } from "react";

// Syncs async AI extraction data into the SbsCellStateProvider after it loads.
// Needed because SbsCellStateProvider only reads initialState on mount.
export const AiCellStateSyncer = ({
  cellStateMap,
}: {
  cellStateMap: SbsCellStateMap;
}): null => {
  const { setCellStateMap } = useSbsCellState();

  useEffect(() => {
    // Never overwrite a populated provider map with an empty one — a transient
    // empty map (e.g. mid-refetch) must not wipe already-rendered AI notations.
    if (Object.keys(cellStateMap).length === 0) return;
    setCellStateMap(cellStateMap);
  }, [cellStateMap, setCellStateMap]);

  return null;
};
